<div class="link-up-workstations-list-container">
  @for (workstation of workstations; track workstation) {
    <pdq-card variant="popover" color="white">
      <div class="workstation-card-wrapper">
        <header>
          <div class="header-left">
            <div style="display: flex; justify-items: center; gap: 8px">
              <pdq-icon icon="monitor-screen"></pdq-icon>
              <div class="title">
                <pdq-heading element="h" [ellipsis]="true">{{ workstation.name }}</pdq-heading>
              </div>
              <div class="online-indicator" [ngClass]="{ active: workstation?.active }"></div>
            </div>
            <span class="activated-by">{{ workstation.activatedBy?.split('@')[0] }}</span>
          </div>
          <div class="header-right">
            @if (linkUpService.isCurrentUserWorkstation(workstation)) {
              <span class="action" (click)="openDeactivateDialog(workstation)">Deactivate</span>
            }
            @if (linkUpService.isCurrentUserWorkstation(workstation)) {
              <span class="action" (click)="openRenameDialog(workstation)">Rename</span>
            }
          </div>
        </header>
        <link-up-workstation-devices
          [devices]="workstation.devices"
          [shareable]="currentPdqUser?.email === workstation?.activatedBy"></link-up-workstation-devices>
      </div>
    </pdq-card>
  }
</div>
